import { postRequest } from '../request/request.service';
import { SignUpPayload, SignUpResponse } from './registration.service.types';

export async function register(data: SignUpPayload) {
  return postRequest<SignUpResponse>('/auth/register', {
    data: { registration: data },
  });
}
